'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BundlePage = require('../BundlePage');

var _ShoppingCartItem = require('./ShoppingCartItem');

var _ShoppingCartItem2 = _interopRequireDefault(_ShoppingCartItem);

var _merchandiseUtils = require('../../../utils/merchandiseUtils');

var _FormattedReactMessage = require('I18n/components/FormattedReactMessage');

var _FormattedReactMessage2 = _interopRequireDefault(_FormattedReactMessage);

var _FormattedNumber = require('I18n/components/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ContactsItem() {
  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      mergeState = _useContext.mergeState;

  var marketingPlanSelected = state.marketingPlanSelected,
      marketingUnits = state.marketingUnits;


  var included = (0, _merchandiseUtils.includedAdditionalUnits)(marketingPlanSelected);

  return _react2.default.createElement(_ShoppingCartItem2.default, {
    merchandiseId: marketingPlanSelected,
    additionalUnitQuantity: included + marketingUnits,
    unit: _react2.default.createElement(_FormattedReactMessage2.default, {
      message: 'bundles.shoppingCart.additionalContacts',
      options: {
        contacts: _react2.default.createElement(_FormattedNumber2.default, { value: included + marketingUnits })
      }
    }),
    onRemove: function onRemove() {
      return mergeState({ marketingPlanSelected: null, marketingUnits: 0 });
    }
  });
}

exports.default = ContactsItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/ContactsItem.js
// module id = 706
// module chunks = 3 4